import "./style.css";
import { useTranslation } from 'react-i18next';
import { changeLanguage } from 'i18next';

import Pagination from './imamComponents/PaginationI'
import background from "./img/background1.jpg"
import useLanguageSetup from "./useLanguageSetup.js";

import {
    NavHeader,
    NavHeaderActions,
    NavHeaderActionBtn,
    Accordion,
    TextInput,
    Button
} from "platformscode-react";

import { Tick02Icon, Search01Icon, } from "@hugeicons/react-pro"

import React, { useState, useRef, useEffect } from "react";

function App() {
    // Translation 
      useLanguageSetup();
      
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language;


    const [accordionData, setAccordionData] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [filteredData, setFilteredData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);



    useEffect(() => {
        const items = t("accordion.items", { returnObjects: true });

        const accordion = Array.isArray(items) ? items.map((item) => ({
            title: item.title,
            content: (
                <div >
                    <p className="inline" dangerouslySetInnerHTML={{ __html: item.content }} />
                    <p className="text-primary  link" dangerouslySetInnerHTML={{ __html: item.link }} />
                </div>
            ),

            contentText: typeof item.content === "string" ? item.content : "",
        })) : [];
        setAccordionData(accordion);
        setFilteredData(accordion);
        setSearchText("");

    }, [currentLang]);



    const handleSearch = () => {
        const search = searchText.toLowerCase();
        const filtered = accordionData.filter((item) =>
            item.title.toLowerCase().includes(search) ||
            item.contentText.toLowerCase().includes(search)
        );
        setFilteredData(filtered);
        setCurrentPage(1);
    };

    // Start page number 
    const itemsPerPage = 10;
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentItems = filteredData.slice(startIndex, endIndex);
    // const currentItems = accordionsData.slice(startIndex, endIndex);
    const paginate = (pageNumbers) => setCurrentPage(pageNumbers);
    // End page number 

    return (
        <>
 


            {/* Page Title */}
            < div className=" flex flex-col gap-[16px] lg:px-[80px] px-[var(--spacing-xl,16px)] bg-[var(--background-primary-25,#F7FDF9)] py-[45px] mb-[40px]"

                style={{
                    backgroundImage: `url(${background})`,
                    backgroundPosition: 'bottom center',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover'
                }} >

                <h1 class="text-[var(--text-default,#161616)] text-[40px] leading-[60px] font-[600] tracking-[-0.96px]">  {t('faq.title')}</h1>
                <p className="text-[var(--text-default,#161616)] text-[16px] font-[400] leading-[24px]  mb-[40px]">
                    {t('faq.description')}
                </p>
            </div >



            <div className="py-[calc(var(--spacing-3xl,24px))] lg:py-[calc(var(--spacing-4xl,32px))] !pb-0">

                <div className="lg:px-[var(--spacing-8xl,80px)] px-[var(--spacing-xl,16px)] mb-[40px]">
                    <form className="flex flex-row w-[34%] items-center m-[10px]" onSubmit={(e) => { e.preventDefault(); handleSearch(); }}>

                        <TextInput
                            placeholder={t("textinput_placeholder_search")}
                            size="lg"
                            variant="default"
                            value={searchText}
                            icon={<Search01Icon />}
                            feedbackIconType={<Search01Icon />}
                            onChange={(e) => setSearchText(e.target.value)}

                        />

                        <Button
                            label={t("Button_search")}
                            size="lg"
                            style="primary-brand"
                            leadIcon
                            type="submit"

                        />
                    </form>

                    {currentItems.map((item, index) => (
                        <Accordion
                            key={`${currentPage}-${index}`}
                            title={item.title}
                            content={item.content}
                        />
                    ))}
                </div>
            </div>

            <div className="flex justify-center pb-[20px]">
                <Pagination
                    itemsPerPage={itemsPerPage}
                    totalItems={filteredData.length}
                    paginate={paginate}
                />
            </div>



        </>
    );
}

export default App;

